import React from 'react';
import _ from 'lodash';

import { useNetSuiteDepartmentSelectFieldQuery } from 'generated/graphql';



export interface INetSuiteDepartment {
  id: string;
  displayName: string;
}

export interface IData {
  objects: INetSuiteDepartment[];
}

export function useQuery() {
  const queryTuple = useNetSuiteDepartmentSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.departments ?? [], (node): INetSuiteDepartment => ({
        id: node.id,
        displayName: node.name
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
